import { Toggle } from '@assembly-js/design-system';
import React from 'react';

type SettingsToggleProps = React.ComponentProps<typeof Toggle>;

// The DS disabled state fades the track to 25% opacity, which reads as a
// different, lower-contrast switch next to the rest of settings, and its
// important rules can't be overridden from here. So a "disabled" settings
// toggle renders the standard enabled look and is made inert instead; the
// upgrade tooltip around it explains why it can't be changed.
const SettingsToggle: React.FC<SettingsToggleProps> = ({
  disabled = false,
  onChange,
  ...rest
}) => (
  <div className={disabled ? 'pointer-events-none' : undefined}>
    <Toggle
      {...rest}
      onChange={disabled ? () => undefined : onChange}
      tabIndex={disabled ? -1 : rest.tabIndex}
      aria-disabled={disabled || undefined}
    />
  </div>
);

export default SettingsToggle;
